export default __webpack_public_path__ + "static/media/Transparency.6fd7c83a.jpg";